import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL, // Replace with your API's base URL
  withCredentials: false
});

// Add token to every request if available
api.interceptors.request.use((config) => {
  const needsAuth = config.headers.needsAuth;
  const storedAuth = localStorage.getItem('auth');
  const needsCsrfToken = config.headers.needsCsrfToken;
  if (needsAuth) {
    if (storedAuth) {
      const { token, csrf_token } = JSON.parse(storedAuth);
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
        if (needsCsrfToken) {
          config.headers['X-CSRF-Token'] = `${csrf_token}`; // Add CSRF token if needed
        }
      }
    }
  }

  delete config.headers.needsAuth;
  if (needsCsrfToken) {
    delete config.headers.needsCsrfToken;
  }
  return config;
});

export default api;
